import { createColDef } from '@fortem-monorepo/react-ag'

import { TradeTypeCellEditor } from '@/ag-grid/columns/trade-type/cell-editor'
import { TradeTypeCellRenderer } from '@/ag-grid/columns/trade-type/renderer'

export const trade_type = createColDef({
  field: 'trade_type',
  headerName: 'Trade Type',
  cellRenderer: TradeTypeCellRenderer,
  cellEditor: TradeTypeCellEditor,
  width: 200,
})
